module.exports = __webpack_public_path__ + "static/media/TitilayoOlowoniyi.bd409e22.jpg";